// Set editörü satır ⋯ menüsü (DR15 + K-B9) — SetTreeEditor'den saf taşıma (600 satır sınırı).
import { kpiCatalogCategoryIds, type KpiCatalogNodeRef, type KpiRowKind } from "@mahir/shared";
import { KPI_COPY } from "../../lib/kpi-ui";
import { type SetRowMenuItem } from "./SetRowMenu";

/** Üye satırının kırılım seviyesi: grubu bir üyenin altındaysa 2, değilse 1; üye değilse 0. */
export function memberLevelOf(
  id: string,
  bv: {
    isMember: (id: string) => boolean;
    groupOf: (id: string) => { parentId: string | null } | null;
  },
): 0 | 1 | 2 {
  const g = bv.groupOf(id);
  if (!g) return 0;
  return g.parentId !== null && bv.isMember(g.parentId) ? 2 : 1;
}

/**
 * "+ Kırılım grubu ekle" işleyicisi; `locked(id)` true ise menüde gösterilmez (TODO-KPI-128 FE:
 * katalog kategorisi — kök global yaprak dahil — altına grup yalnız Sistem Yöneticisi).
 */
export type GroupAddHandler = ((id: string) => void) & {
  locked?: ((id: string) => boolean) | undefined;
};

/**
 * Set satırı (kimlik) → grup kilidi: kategori izni yoksa metriği katalog KATEGORİSİ olan satır
 * (`kpiCatalogCategoryIds` — kök global yaprak dahil) kilitli; katalog yüklenmediyse kilit yok
 * (sunucu 403 son ağdır).
 */
export function groupLockFor(
  rows: readonly { id: string; metricId: string }[],
  catalog: readonly KpiCatalogNodeRef[] | null,
  canManageCategories: boolean,
): (id: string) => boolean {
  if (canManageCategories || !catalog) return () => false;
  const categories = kpiCatalogCategoryIds(catalog);
  const metricOf = new Map(rows.map((r) => [r.id, r.metricId]));
  return (id) => {
    const metricId = metricOf.get(id);
    return metricId !== undefined && categories.has(metricId);
  };
}

/** Satır ⋯ menüsü (DR15): gösterge/toplam → "+ Kırılım grubu ekle"; grup → "+ Üye" + kaldır. */
export function rowMenuItems(
  id: string,
  kind: KpiRowKind,
  isMember: boolean,
  h: {
    onAddBreakdownGroup?: GroupAddHandler | undefined;
    onAddBreakdownMember?: ((groupId: string) => void) | undefined;
    onRemoveRow?: ((id: string) => void) | undefined;
    /** TODO-KPI-116: yalnız eski değeri olan kategori satırında verilir */
    onConvertLegacy?: ((id: string) => void) | undefined;
  },
  /** üyenin kırılım seviyesi (0 = üye değil): yalnız seviye-1 üyenin altına grup açılır (K-B9) */
  memberLevel: 0 | 1 | 2 = 0,
): SetRowMenuItem[] {
  const C = KPI_COPY.breakdown.tree;
  const out: SetRowMenuItem[] = [];
  if (
    (kind === "metric" || kind === "total") &&
    (!isMember || memberLevel === 1) &&
    h.onAddBreakdownGroup &&
    h.onAddBreakdownGroup.locked?.(id) !== true
  ) {
    const fn = h.onAddBreakdownGroup;
    out.push({ key: "add-group", label: C.addGroup, onSelect: () => fn(id) });
  }
  if (kind === "category" && h.onConvertLegacy) {
    const fn = h.onConvertLegacy;
    out.push({ key: "convert-legacy", label: C.legacyValuesAction, onSelect: () => fn(id) });
  }
  if (kind === "breakdown_group") {
    if (h.onAddBreakdownMember) {
      const fn = h.onAddBreakdownMember;
      out.push({ key: "add-member", label: C.addMember, onSelect: () => fn(id) });
    }
    if (h.onRemoveRow) {
      const fn = h.onRemoveRow;
      out.push({ key: "remove", label: C.removeGroup, onSelect: () => fn(id), tone: "danger" });
    }
  }
  return out;
}
